var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rl-carousel',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var wrapperStyles = ref.wrapperStyles;
var ref_slides = ref.slides;
var count = ref_slides.count;
var active = ref_slides.active;
var moveTo = ref_slides.moveTo;
return _c('div',{},[_c('div',{staticClass:"overflow-hidden"},[_c('div',_vm._b({staticClass:"w-full"},'div',wrapperStyles,false),[_vm._t("default")],2)]),_c('div',{staticClass:"absolute w-full pin-b flex items-end justify-end pr-8 pb-8"},_vm._l((count),function(item,index){return _c('div',{key:index,staticClass:"mb-2 mr-2 p-1 cursor-pointer text-center",class:{ active: active === index },on:{"click":function($event){_vm.slide = index
          _vm.autoscroll = false}}},[_c('span',{class:{
            'text-grey text-base': active !== index,
            'text-2xl active': active === index
          }},[_vm._v("\n          "+_vm._s(item)+"\n        ")])])}),0)])}}],true),model:{value:(_vm.slide),callback:function ($$v) {_vm.slide=$$v},expression:"slide"}})}
var staticRenderFns = []

export { render, staticRenderFns }